// Unpublished Work © 2021-2025 Deere & Company.

import {
    RESET_CUSTOMER_PROFILE,
    SET_CROSS_REFERENCE_DATA,
    SET_PROFILE_DATA,
    UPDATE_PROFILE_MEMBERSHIP,
    UPDATE_PROFILE_ORGANIZATION
} from '../../action-list';
import {Customer} from '../../state/struct/customer';

const setProfileData = (state, action) => new Customer(action.customerProfile.customer);

const updateSelectedDBSMembership = (state, action) => Customer.update(state, {
    selectedDBS: {
        $set: action.value
    }
});

const updateSelectedOrganization = (state, action) => Customer.update(state, {
    selectedOrganization: {
        $set: action.orgId
    }
});

const resetCustomerProfile = () => new Customer({});

export function customer(state = new Customer({}), action = {}) {
    const actionHandlers = {
        [RESET_CUSTOMER_PROFILE]: resetCustomerProfile,
        [SET_PROFILE_DATA]: setProfileData,
        [SET_CROSS_REFERENCE_DATA]: setProfileData,
        [UPDATE_PROFILE_MEMBERSHIP]: updateSelectedDBSMembership,
        [UPDATE_PROFILE_ORGANIZATION]: updateSelectedOrganization
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
